import { render, staticRenderFns } from "./BoxNowWidget.vue?vue&type=template&id=afd90eea"
import script from "./BoxNowWidget.vue?vue&type=script&lang=js"
export * from "./BoxNowWidget.vue?vue&type=script&lang=js"
import style0 from "./BoxNowWidget.vue?vue&type=style&index=0&id=afd90eea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports